import React from "react";
import classNames from "classnames";
import Icon from '../../Icon/Icon';
import styles from '../DateField.module.scss';

const DateFieldNavbar = ({ onPreviousClick, onNextClick, className }: any) =>  {
  return (
    <div className={classNames(className, styles.navbar)}>
      <button type="button" onClick={() => onPreviousClick()}>
        <Icon
          iconVariant={Icon.Variants.FontAwesome}
          icon="fas fa-chevron-left"
        />
      </button>
      <button type="button" onClick={() => onNextClick()}>
        <Icon
          iconVariant={Icon.Variants.FontAwesome}
          icon="fas fa-chevron-right"
        />
      </button>
    </div>
  );
}

export default DateFieldNavbar;
